import { render, staticRenderFns } from "./FichaModal.vue?vue&type=template&id=b60f3e10&scoped=true"
import script from "./FichaModal.vue?vue&type=script&lang=js"
export * from "./FichaModal.vue?vue&type=script&lang=js"
import style0 from "./FichaModal.vue?vue&type=style&index=0&id=b60f3e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60f3e10",
  null
  
)

export default component.exports